/* eslint-disable */
export default {
  getPortos(state) {
    return state.portos;
  },
};
